import axios from "axios";
import store from "../store";
import urlParse from "./urlParse";
// import aLiurlParse from "./aLiurlParse";

const getUserAuth = (redirectUrl, source ,brandIdStr, storeIdStr) => {
  return axios.post(`/auth/h5/authUrl`, {
    data: {
      redirectUrl, source, brandIdStr, storeIdStr
    }});
}

const auth = (param) => {
  let curUrl = param || location.origin + location.pathname + location.hash + (location.search ? location.search : '')
  let brandIdStr = store.state.brandIdStr
  let storeIdStr = store.state.storeIdStr
  const source = store.state.isApp === 'isAlipay' ? 3 : 2
  getUserAuth(curUrl, source, brandIdStr, storeIdStr).then((res) => {
    console.log('res', res)
    const { errCode, data: url } = res.data
    console.log('code', errCode)
    console.log('url', url)
    if (errCode === '0') {
      window.location.href = url
    } else {
      console.log('res')
    }
  }).catch((err) => {

  })
  // 微信获取code 地址
  // 支付宝获取Auth_code 地址
  // let appId = ''
  // if (process.env.NODE_ENV === "test") {
  //   appId = '2021001156627730'
  // } else if (process.env.NODE_ENV === "production") {
  //   appId = '2021001103697575'
  // }
  // let url
  // if (window.isWeixin) {
  //   url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4480c4cf404b16ca&redirect_uri=${encodeURIComponent(curUrl)}&response_type=code&scope=snsapi_base&state=#wechat_redirect`
  // } else if (window.isAlipay) {
  //   url = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${appId}&scope=auth_base&redirect_uri=${encodeURIComponent(curUrl)}`
  // } else {
  //   this.$toast('请使用支付宝/微信扫描二维码!')
  // }
  // console.log('url', url)
  // location.replace(url)
  // window.location.href = url
}
export default auth
